import { trackPromise } from 'react-promise-tracker';

const validate = (r) => {
  if (r.data?.errorMsg && r.data?.errorMsg !== '0000') throw r.data;
};

export default function createUserOperationAPI(axios) {
  return {
    postUserRegister: async (email, name, phone, password) => {
      try {
        const data = {
          email,
          name,
          phone,
          password,
        };

        const result = await trackPromise(axios.post('/api/Auth/Register', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          email,
          password,
          phone,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    activateAccount: async (email, code) => {
      try {
        const data = {
          email,
          verifyCode: code,
        };

        const result = await trackPromise(axios.post('/api/Auth/VerifyEmail', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          email,
          code,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postUserLogin: async (email, password, verifyCode = '') => {
      try {
        const data = {
          email,
          password,
          verifyCode,
        };
        const result = await trackPromise(axios.post('/api/Auth/Login', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          email,
          password,
          verifyCode,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postUpdateUserPassword: async (newPassword, oldPassword) => {
      try {
        const data = {
          newPassword,
          oldPassword,
        };
        const result = await trackPromise(axios.post('/api/Auth/UpdateUserPassword', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          newPassword,
          oldPassword,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postForgotPassword: async (email, phone) => {
      try {
        const data = {
          email,
          phone,
        };
        const result = await trackPromise(axios.post('/api/Auth/ForgotPassword', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          email,
          phone,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    postUpdateUserInfo: async (name, phone, role) => {
      try {
        const data = {
          name,
          phone,
          role,
        };
        const result = await trackPromise(axios.post('/api/Auth/UpdateUserInfo', data));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          name,
          phone,
          role,
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
    getUserInfo: async () => {
      try {
        const result = await trackPromise(axios.get('/api/Auth/UserInfo'));
        validate(result);
        return result.data;
      } catch (error) {
        const errorMessage = {
          error: error.response && error.response.data ? error.response.data : error,
        };
        return errorMessage;
      }
    },
  };
}
